import { NomenclatorValue } from './nomenclator.dictionary'

export enum ComponentIdentifierEnum {
  PAGE = 'PAGE',
  MODAL = 'MODAL',
  STEPPER = 'STEPPER',
  STEP = 'STEP',
  TAB_BAR = 'TAB_BAR',
  TAB = 'TAB',
  CONTAINER = 'CONTAINER',
  ZONE = 'ZONE',
  FORM = 'FORM',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  LINK = 'LINK',
  BUTTON = 'BUTTON',
  FILE_UPLOAD = 'FILE_UPLOAD',
  BULK_FILE_UPLOAD = 'BULK_FILE_UPLOAD',
  FILE_DOWNLOAD = 'FILE_DOWNLOAD',
  MESSAGE = 'MESSAGE',
  COLLECTION = 'COLLECTION',
  COLLECTION_PROTOTYPE = 'COLLECTION_PROTOTYPE',
  CARD = 'CARD',
  DOCUMENT_PREVIEW = 'DOCUMENT_PREVIEW',
  TABLE = 'TABLE',
  TABLE_ROW = 'TABLE_ROW',
  TABLE_CELL = 'TABLE_CELL',
  VIEWPORT = 'VIEWPORT',
  SUBPROCESS_EMBED = 'SUBPROCESS_EMBED',
  REUSABLE_TEMPLATE = 'REUSABLE_TEMPLATE',
  TEXTAREA = 'TEXTAREA',
  TASK_MANAGEMENT = 'TASK_MANAGEMENT',
  CHAT = 'CHAT',
  CHAT_INPUT = 'CHAT_INPUT',
  CHAT_HEADER = 'CHAT_HEADER',
  CHAT_HISTORY = 'CHAT_HISTORY',
  CHAT_HISTORY_ITEM = 'CHAT_HISTORY_ITEM',
  CHAT_HISTORY_SECTION = 'CHAT_HISTORY_SECTION',
  CHAT_MESSAGES = 'CHAT_MESSAGES',
  CHAT_SUGGESTED_PROMPTS = 'CHAT_SUGGESTED_PROMPTS',
  CHAT_AGENT_MESSAGE = 'CHAT_AGENT_MESSAGE',
  CHAT_ERROR_MESSAGE = 'CHAT_ERROR_MESSAGE',
  CHAT_USER_MESSAGE = 'CHAT_USER_MESSAGE',
  CHAT_USER_VOICE_MESSAGE = 'CHAT_USER_VOICE_MESSAGE',
  CHAT_VOICE_INPUT = 'CHAT_VOICE_INPUT',
  CHAT_TEXT_INPUT = 'CHAT_TEXT_INPUT',
  CHAT_REASONING = 'CHAT_REASONING',
  CHAT_FILE_ATTACHMENTS = 'CHAT_FILE_ATTACHMENTS',
  CHAT_FILE_ITEM = 'CHAT_FILE_ITEM',
  CHAT_USER_ATTACHED_FILES = 'CHAT_USER_ATTACHED_FILES',
  CHAT_USER_FILE_ITEM = 'CHAT_USER_FILE_ITEM',
  CHAT_MESSAGE_ACTIONS = 'CHAT_MESSAGE_ACTIONS',
  BREADCRUMBS = 'BREADCRUMBS',
  PROCESS_RENDERER = 'PROCESS_RENDERER',
  SEPARATOR = 'SEPARATOR',
  PROGRESS_BAR = 'PROGRESS_BAR',
  MARKDOWN = 'MARKDOWN',
  TOOLTIP = 'TOOLTIP',
  HEADER = 'HEADER',
  FOOTER = 'FOOTER',
  CARD_HEADER_ACTIONS = 'CARD_HEADER_ACTIONS',
  CARD_FOOTER_ACTIONS = 'CARD_FOOTER_ACTIONS',
  STATS_CARD = 'STATS_CARD',
  BADGE = 'BADGE',
  AVATAR = 'AVATAR',
  ALERT = 'ALERT',
  RATING = 'RATING',
  TIMELINE = 'TIMELINE',
  EMPTY_STATE = 'EMPTY_STATE',
  SKELETON = 'SKELETON',
  PROGRESS_RING = 'PROGRESS_RING',
  DESCRIPTION_LIST = 'DESCRIPTION_LIST',
  TAG_GROUP = 'TAG_GROUP',
  STEP_INDICATOR = 'STEP_INDICATOR',
  CHART = 'CHART',
}

export enum FormFieldsEnum {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  DATEPICKER = 'DATEPICKER',
  SWITCH = 'SWITCH',
  SEGMENTED_BUTTON = 'SEGMENTED_BUTTON',
  SLIDER = 'SLIDER',
}

export type ComponentType = ComponentIdentifierEnum | FormFieldsEnum
export type Platform = 'web' | 'android' | 'ios'

export enum TemplateConfigType {
  CUSTOM = 'CUSTOM',
  FLOWX = 'FLOWX',
}

export type CollectionPrototypeInstanceMeta = {
  index: number
  collectionPath: string
}

export interface DataSource {
  // optional until the migration is done and sourceType
  // will be the only source of truth
  sourceType?: DataSourceType
  defaultValue?: any
  options?: NomenclatorValue[]

  nomenclator?: {
    name: string | number
    parentFlowxUuid?: string
  }

  processData: {
    key: string
    parentFlowxUuid?: string
  }
  isComputedDefault?: boolean
  isRepeatable?: boolean
}

export enum DataSourceType {
  STATIC = 'static',
  ENUMERATION = 'enumeration',
  PROCESS_DATA = 'processData',
}

export enum ValidatorType {
  SYNC = 'sync',
  ASYNC = 'async',
}

export enum InputType {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email',
  PASSWORD = 'password',
  CODE = 'code',
}

export type FlxDataSource = {
  defaultValue: string
  isComputedDefault?: boolean
  label: string
  placeholder: string
  inputType?: InputEvent
}

export type FlxValidator = {
  name: string
  message: string
  isCustom: boolean
  type?: 'async' | 'sync'
  params?: any[]
  isComputedParams?: boolean
}

export type FlxField = {
  uuid: string
  key: string
  componentIdentifier: FormFieldsEnum
  dataSource: FlxDataSource
  validators: FlxValidator[]
}

export type FlxFormObject = {
  uuid: string
  fields: FlxField[]
}

/** Pre-6.1 image source. Read only in file-source compatibility mode. */
export enum ImageSourceTypeOptions {
  URL = 'URL',
  BASE64 = 'BASE64',
  DOCUMENT_PLUGIN = 'DOCUMENT_PLUGIN',
}

export interface ProcessNotification {
  identifier: string
  componentIdentifier: 'MESSAGE'
  displayOptions?: {
    flowxProps: {
      messageType: string
      text: string
      layoutType: string
      displayType: string
    }
  }
  action?: {
    url?: string
    src?: string
    label: string
  }
  show: boolean
}
